import { ComponentPropsWithoutRef, useState } from 'react';
import { Button } from '@givebutter/primitives/button';
import { twMerge } from 'tailwind-merge';

interface ExpandableImageProps extends ComponentPropsWithoutRef<'img'> {}

const ExpandableImage = (props: ExpandableImageProps) => {
    const { className, alt = 'Expandable image', ...rest } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Button variant="none" onClick={() => setIsExpanded(isExpanded => !isExpanded)}>
            <img
                alt={alt}
                className={twMerge(
                    isExpanded && 'h-60',
                    !isExpanded && 'h-20',
                    'rounded',
                    className,
                )}
                {...rest}
            />
        </Button>
    );
};

export { ExpandableImage };
